import styled from 'styled-components'

import { FontRegular, FontLight, Breakpoints } from './../../utils/variables'

export const Member = styled.li`
	margin-bottom: 25px;

	&:last-of-type {
		margin-bottom: 0;
	}

	@media screen and (min-width: ${Breakpoints.wide}) {
		margin-bottom: 0;
	}
`

export const ImageWrapper = styled.figure`
	position: relative;
	
	padding: 0;
	padding-bottom: 100%;
	
	background-color: rgba(0, 0, 0, 0.1);
	
	margin: 0;
	margin-bottom: 20px;
`

export const Image = styled.img`
	position: absolute;

	top: 0;
	left: 0;

	width: 100%;
	height: 100%;

	object-fit: cover;
	object-position: center;
`

export const Name = styled.h4`
	margin-bottom: 20px;

	${FontRegular}
	font-size: 18px;
	line-height: 25px;
`

export const Title = styled.span`
	display: block;

	${FontLight}
	font-size: 13px;
	line-height: 20px;

	@media screen and (min-width: ${Breakpoints.wide}) {
		font-size: 14px;
		line-height: 25px;
	}
`